import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/artwork',
    name: 'artwork2',
    meta: {transitionName: 'slide'},
    component: () => import('../views/ArtWork2.vue')
  },
  {
    path: '/artwork/making',
    name: 'artworkMaking',
    meta: {transitionName: 'slide'},
    component: () => import('../views/UntilWorkIsMade.vue')
  },
  {
    path: '/artwork/past/works',
    name: 'pastWorks',
    meta: {transitionName: 'slide'},
    component: () => import('../views/PastWorks.vue')
  },
  {
    path: '/exhibition/:pageNo',
    name: 'exhibition',
    meta: {transitionName: 'slide'},
    props: true,
    component: () => import('../views/Exhibition.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
